import React from 'react';

import { HotelSearchResultsContainer } from './HotelSearchResults';
import HotelRoomCard from './HotelRoomCard';

import type { Room } from '@lt/api/dist/methods/search/types';

export interface IHotelRooms {
  hotelRoomsData: Array<Room>;
  currencySymbol?: string;
  redirectToHotelPage: (nightsCount?: number) => void;
  isMobile: boolean;
  areSmallCards: boolean;
}

const HotelRooms = (props: IHotelRooms): JSX.Element => {
  const { currencySymbol, redirectToHotelPage, isMobile, areSmallCards, hotelRoomsData } = props;

  return (
    <HotelSearchResultsContainer $isMobile={isMobile}>
      {hotelRoomsData.map((hotelRoomData) => (
        <HotelRoomCard
          isMobile={isMobile}
          isSmall={areSmallCards}
          key={hotelRoomData.ID}
          hotelRoomData={hotelRoomData}
          currencySymbol={currencySymbol}
          redirectToHotelPage={redirectToHotelPage}
          // selectMealType={(mealType: string) => setSelectedMealType(mealType)}
        />
      ))}
    </HotelSearchResultsContainer>
  );
};

export default HotelRooms;
